
























import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";

type StatisticItem = {
    activity_id: number,
    content_pack_id: number,
    duration: number,
    players_count: string
}

@Component({
    components: {},
})

export default class TableTotal extends Vue {
    @Prop({required: true}) private readonly info!: {[key: string]: Array<StatisticItem>};

    mounted(): void {

    }

    private getSum(playersCount: string): number
    {
        let sum = 0;
        if (playersCount === '0') {
            for (let item in this.info) {
                this.info[item].forEach(info => {
                    sum += +info.duration;
                });
            }
        } else {
            for (let item in this.info) {
                this.info[item].forEach(info => {
                    if (info.players_count === playersCount) {
                        sum += +info.duration;
                    }
                });
            }
        }

        return sum;
    }
}
